import { Button, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { imageURL } from 'Config/endpoints';
import React from 'react';
import { useMutation, useQuery } from 'react-query';
import EditIcon from '@mui/icons-material/Edit';
import { deleteBlogCategoryFn, getBlogCategoryFn } from 'Services/Blog';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';

const BlogCategory = () => {
    const navigate = useNavigate();

    const { data: getBlogCategoryResponse, refetch } = useQuery({
        queryFn: getBlogCategoryFn,
        queryKey: ['get-blog-category'],
    });

    const { mutate: deleteCategory } = useMutation(deleteBlogCategoryFn, {
        onSuccess: (response) => {
            toast.success("Category deleted successfully.");
            refetch();
        },
    });

    const handleDelete = (id) => {
        const formData = new FormData();
        formData.append("blog_category_id", id);
        deleteCategory(formData);
    };

    const getBlogs = getBlogCategoryResponse?.data?.data;

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <Typography variant="h5" component="h2" className='!text-black font-bold'>
                    Blog Category
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate(`/blog/category/add`)}
                >
                    Add
                </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {getBlogs?.map((category) => (
                    <Card key={category?.id} className="bg-white shadow-md rounded-lg">
                        <CardMedia
                            component="img"
                            style={{ height: '200px', objectFit: 'cover' }}
                            image={imageURL(category?.image)}
                            alt={category?.name}
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h6" component="div">
                                {category?.name || "--"}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button
                                size="small"
                                color="primary"
                                onClick={() => navigate(`/blog/category/update/${category?.id}`)}
                            >
                                <EditIcon />
                                Edit
                            </Button>
                            <Button
                                size="small"
                                color='error'
                                onClick={() => handleDelete(category?.id)}
                            >
                                <DeleteIcon />
                                Delete
                            </Button>
                        </CardActions>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default BlogCategory;
